export default "__VITE_ASSET__px5vRYzV__"